import { useAppContext } from '../../contexts/AppContext'
import Spinner from './Spinner'

const Button = ({ label, onClick, icon, disabled, className, loading }) => {
  const { accentColor } = useAppContext()
  return (
    <div
      ref={ref => {
        if (!ref) return
        ref.style.width = `${ref.offsetWidth}px`
      }}
      style={{ background: accentColor, borderColor: accentColor }}
      className={`
        leading-8 min-w-80 max-sm:min-w-32 rounded-md items-center justify-center flex gap-2 px-5 py-1 
        border-[1px] border-transparent fill-[#c2c2c2] text-[#c2c2c2] ${className}
       ${
         disabled
           ? 'text-[#bbb] dark:text-zinc-500 fill-[#bbb] dark:fill-zink-500 outline outline-1 outline-[#bbb] dark:outline-zinc-500 cursor-not-allowed'
           : `
            text-[#070707] dark:text-zinc-400 fill-[#070707] dark:fill-zinc-400 bg-wp-dark dark:bg-zinc-700 
              cursor-pointer dark:hover:bg-zinc-600 hover:text-white hover:fill-white
            `
       }`}
      onClick={onClick}
    >
      {loading ? (
        <div className="py-1">
          <Spinner isActive={true} />
        </div>
      ) : (
        <>
          {icon}
          <span>{label}</span>
        </>
      )}
    </div>
  )
}

export default Button
